import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function ArticleHeader() {
  return <section id="article-header" className="bg-background py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <header className="mb-10">
          <h1 className="mb-4 font-sans text-[32px] md:text-[38px] lg:text-[44px] font-bold leading-[1.1] tracking-[-0.02em] text-foreground">
            The Future of Institutional Finance: A Comprehensive Analysis
          </h1>
          <p className="max-w-3xl font-sans text-[16px] md:text-[18px] lg:text-[20px] leading-relaxed text-muted-foreground">
            Exploring the macro-economic shifts and technological advancements driving the next decade of wealth management and asset allocation strategies.
          </p>
        </header>

        <div className="overflow-hidden rounded-md border-t-4 border-secondary bg-muted shadow-sm">
          <AspectRatio ratio={16 / 9}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/institutional_finance_header.png" alt="Abstract representation of institutional finance and market trends" className="h-full w-full object-cover" />
          </AspectRatio>
        </div>
      </div>
    </section>;
}